/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import './FooterTop.scss'

function FooterTop () {
  return (
    <div className='footer_top'>
      <ul className='ultop'>
        <li>
          <a>
            <img src='/iconphone.png' alt='' />
            <p>สายด่วน</p>
          </a>
        </li>

        <li>
          <a>
            <img src='/iconemail.png' alt='' />
            <p>QK88BETcom@gmail.com</p>
          </a>
        </li>

        <li>
          <a>
            <img src='/icondaily.png' alt='' />
            <p>ตัวแทน</p>
          </a>
        </li>

        <li>
          <a>
            <img src='/iconsecurity.png' alt='' />
            <p>คู่มือป้องกันการแฮ็ก DNS</p>
          </a>
        </li>

        <li>
          <a>
            <img src='/iconservice.png' alt='' />
            <p>บริการลูกค้า</p>
          </a>
        </li>
      </ul>
    </div>
  )
}

export default FooterTop